//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import dxSelectBox, { dxSelectBoxOptions } from 'devextreme/ui/select_box'
import dxValidator, { dxValidatorOptions } from 'devextreme/ui/validator'
import dxTagBox, { dxTagBoxOptions } from 'devextreme/ui/tag_box'

//#endregion

//#region Asset Imports

import { IMRBaseControlController } from '../../common/base'

import { LocalizationHelper } from '../../../helpers'
import { UserSessionService } from '../../../services/user-session'
import { ConfigurationProfileService } from '../../../services/configuration-profile'

import { Enums } from '../../../models/common'
import { IIMRConfigurationProfileSchedule, IIMRConfigurationProfileScheduleSubmitResponse, IMRConfigurationProfileScheduleOptions } from './configuration-profile-schedule.interfaces'
import { OpConfigurationProfileData, OpDeviceTypeProfileMap } from '../../../models/core'

//#endregion

enum DayType {
    WorkDay = 1,
    Weekend = 2,
    Holiday = 3,
}

export class ConfigurationProfileScheduleController extends IMRBaseControlController<IIMRConfigurationProfileSchedule, IMRConfigurationProfileScheduleOptions> implements ng.IComponentController, IIMRConfigurationProfileSchedule {
    public popupId: number
    public isLoading: boolean

    public workDaySelectBoxOption: dxSelectBoxOptions[]
    public weekEndSelectBoxOption: dxSelectBoxOptions[]
    public holidaySelectBoxOption: dxSelectBoxOptions[]

    public deviceTypeTagBoxOptions: dxTagBoxOptions
    public deviceTypeTagBoxValidatorOptions: dxValidatorOptions

    public readonly scheduleText: string = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Schedule)
    public readonly hoursText: string = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Hours)
    public readonly workdayText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.WorkDay)
    public readonly weekendText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Weekend)
    public readonly holidaysText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Holidays)
    public readonly deviceTypeText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DeviceType)
    public readonly allowedAlampLevelsText: string = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AllowedAlampLevels)

    public hourList: string[]

    private workDaySelectBox: dxSelectBox[]
    private weekEndSelectBox: dxSelectBox[]
    private holidaySelectBox: dxSelectBox[]
    private deviceTypeTagBox: dxTagBox
    private deviceTypeTagBoxValidator: dxValidator


    private isNew: boolean
    private loadedDeviceTypes: number[]
    private dataSource: OpConfigurationProfileData[]

    private readonly PERIOD_COUNT: number = 24

    constructor(private userSessionService: UserSessionService, private configurationProfileService: ConfigurationProfileService, private $scope: ng.IScope) {
        super()

        this.popupId = new Date().getTime()

    }

    //#region Consts

    //#endregion

    //#region Component

    protected initialize(options: IMRConfigurationProfileScheduleOptions): void {
        if (options != null) {
            this.isNew = _.size(options.dataSource) === 0
            this.dataSource = this.isNew ? [] : _.map(options.dataSource, (item: OpConfigurationProfileData) => {
                return item.clone(true, true, true, true)
            })
            this.setOptions()
        }
    }

    //#endregion

    //#region IIMRAddExternalDevice implementation

    public reset(): void {
        this.dataSource = this.isNew ? [] : _.map(this.options.dataSource, (item: OpConfigurationProfileData) => {
            return item.clone(true, true, true, true)
        })
    }

    public submit(): IIMRConfigurationProfileScheduleSubmitResponse {
        const isValid: boolean = this.deviceTypeTagBoxValidator.validate().isValid

        const currentDeviceTypeids: number[] = this.deviceTypeTagBox.option('value')

        const dataToReturn: OpConfigurationProfileData[] = []

        if (isValid) {
            if (this.isNew) {
                _.forEach(currentDeviceTypeids, (idDeviceType: number) => {
                    for (let i = 0; i < this.PERIOD_COUNT; i++) {
                        const workDayData: OpConfigurationProfileData = new OpConfigurationProfileData(null)
                        workDayData.idDataType = Enums.DataType.DALI_WORKDAY_POWER_LEVEL
                        workDayData.idDeviceType = idDeviceType
                        workDayData.value = this.workDaySelectBox[i].option('value')
                        workDayData.indexNBR = i
                        workDayData.opState = Enums.OpChangeState.New

                        dataToReturn.push(workDayData)

                        const weekEndData: OpConfigurationProfileData = new OpConfigurationProfileData(null)
                        weekEndData.idDataType = Enums.DataType.DALI_WEEKEND_POWER_LEVEL
                        weekEndData.idDeviceType = idDeviceType
                        weekEndData.value = this.weekEndSelectBox[i].option('value')
                        weekEndData.indexNBR = i
                        weekEndData.opState = Enums.OpChangeState.New

                        dataToReturn.push(weekEndData)

                        const holidayData: OpConfigurationProfileData = new OpConfigurationProfileData(null)
                        holidayData.idDataType = Enums.DataType.DALI_HOLIDAY_POWER_LEVEL
                        holidayData.idDeviceType = idDeviceType
                        holidayData.value = this.holidaySelectBox[i].option('value')
                        holidayData.indexNBR = i
                        holidayData.opState = Enums.OpChangeState.New

                        dataToReturn.push(holidayData)

                    }
                })
            } else {
                const allDeviceType: number[] = _.uniq([...currentDeviceTypeids, ... this.loadedDeviceTypes])

                _.forEach(allDeviceType, (idDeviceType: number) => {
                    let deviceTypeOpState: Enums.OpChangeState = Enums.OpChangeState.Loaded

                    if (this.loadedDeviceTypes.indexOf(idDeviceType) > -1 && currentDeviceTypeids.indexOf(idDeviceType) === -1) {
                        deviceTypeOpState = Enums.OpChangeState.Delete
                    } else if (this.loadedDeviceTypes.indexOf(idDeviceType) === -1 && currentDeviceTypeids.indexOf(idDeviceType) > -1) {
                        deviceTypeOpState = Enums.OpChangeState.New
                    }

                    for (let i = 0; i < this.PERIOD_COUNT; i++) {
                        if (deviceTypeOpState === Enums.OpChangeState.Delete) {
                            const workdayData: OpConfigurationProfileData = _.find(this.options.dataSource, (item: OpConfigurationProfileData) => item.idDeviceType == idDeviceType && item.indexNBR == i && item.idDataType == Enums.DataType.DALI_WORKDAY_POWER_LEVEL)

                            if (workdayData != null) {
                                workdayData.opState = deviceTypeOpState
                                dataToReturn.push(workdayData)
                            }

                            const weekendData: OpConfigurationProfileData = _.find(this.options.dataSource, (item: OpConfigurationProfileData) => item.idDeviceType == idDeviceType && item.indexNBR == i && item.idDataType == Enums.DataType.DALI_WEEKEND_POWER_LEVEL)

                            if (weekendData != null) {
                                weekendData.opState = deviceTypeOpState
                                dataToReturn.push(weekendData)
                            }

                            const holidayData: OpConfigurationProfileData = _.find(this.options.dataSource, (item: OpConfigurationProfileData) => item.idDeviceType == idDeviceType && item.indexNBR == i && item.idDataType == Enums.DataType.DALI_HOLIDAY_POWER_LEVEL)

                            if (holidayData != null) {
                                holidayData.opState = deviceTypeOpState
                                dataToReturn.push(holidayData)
                            }
                        } else if (deviceTypeOpState === Enums.OpChangeState.New) {
                            const workDayData: OpConfigurationProfileData = new OpConfigurationProfileData(null)
                            workDayData.idDataType = Enums.DataType.DALI_WORKDAY_POWER_LEVEL
                            workDayData.idDeviceType = idDeviceType
                            workDayData.value = this.workDaySelectBox[i].option('value')
                            workDayData.indexNBR = i
                            workDayData.opState = Enums.OpChangeState.New

                            dataToReturn.push(workDayData)

                            const weekEndData: OpConfigurationProfileData = new OpConfigurationProfileData(null)
                            weekEndData.idDataType = Enums.DataType.DALI_WEEKEND_POWER_LEVEL
                            weekEndData.idDeviceType = idDeviceType
                            weekEndData.value = this.weekEndSelectBox[i].option('value')
                            weekEndData.indexNBR = i
                            weekEndData.opState = Enums.OpChangeState.New

                            dataToReturn.push(weekEndData)

                            const holidayData: OpConfigurationProfileData = new OpConfigurationProfileData(null)
                            holidayData.idDataType = Enums.DataType.DALI_HOLIDAY_POWER_LEVEL
                            holidayData.idDeviceType = idDeviceType
                            holidayData.value = this.holidaySelectBox[i].option('value')
                            holidayData.indexNBR = i
                            holidayData.opState = Enums.OpChangeState.New

                            dataToReturn.push(holidayData)
                        } else {
                            const workdayData: OpConfigurationProfileData = _.find(this.options.dataSource, (item: OpConfigurationProfileData) => item.idDeviceType == idDeviceType && item.indexNBR == i && item.idDataType == Enums.DataType.DALI_WORKDAY_POWER_LEVEL)

                            if (workdayData != null) {
                                const value: number = this.workDaySelectBox[i].option('value')

                                if (value != workdayData.value) {
                                    workdayData.value = value
                                    workdayData.opState = Enums.OpChangeState.Modified
                                } else {
                                    workdayData.opState = Enums.OpChangeState.Loaded
                                }

                                dataToReturn.push(workdayData)
                            }


                            const weekendData: OpConfigurationProfileData = _.find(this.options.dataSource, (item: OpConfigurationProfileData) => item.idDeviceType == idDeviceType && item.indexNBR == i && item.idDataType == Enums.DataType.DALI_WEEKEND_POWER_LEVEL)

                            if (weekendData != null) {
                                const value: number = this.weekEndSelectBox[i].option('value')

                                if (value != weekendData.value) {
                                    weekendData.value = value
                                    weekendData.opState = Enums.OpChangeState.Modified
                                } else {
                                    weekendData.opState = Enums.OpChangeState.Loaded
                                }

                                dataToReturn.push(weekendData)
                            }

                            const holidayData: OpConfigurationProfileData = _.find(this.options.dataSource, (item: OpConfigurationProfileData) => item.idDeviceType == idDeviceType && item.indexNBR == i && item.idDataType == Enums.DataType.DALI_HOLIDAY_POWER_LEVEL)

                            if (holidayData != null) {
                                const value: number = this.holidaySelectBox[i].option('value')

                                if (value != holidayData.value) {
                                    holidayData.value = value
                                    holidayData.opState = Enums.OpChangeState.Modified
                                } else {
                                    holidayData.opState = Enums.OpChangeState.Loaded
                                }

                                dataToReturn.push(holidayData)
                            }
                        }
                    }
                })
            }
        }

        const html: string = isValid ? this.prepareHtmlDescr() : ''

        return {
            data: dataToReturn, htmlString: html, isValid: isValid
        }
    }

    //#endregion

    private setOptions(): void {
        this.isLoading = true

        this.setDeviceTypeTagBoxValidatorOptions()
        this.setDeviceTypeTagBoxOptions()
        this.setAllSelectBoxOptions()

        this.isLoading = false
    }

    private getSelectBoxDataSource(): number[] {
        let i: number = 0
        const source: number[] = []

        do {
            source.push(i)
            i += 10
        } while (i <= 100)

        return source
    }

    private getSingleSelectBoxOptions(index: number, list: dxSelectBox[], idDataType: Enums.DataType, dayType: DayType): dxSelectBoxOptions {
        const data: OpConfigurationProfileData = _.find(this.dataSource, (data: OpConfigurationProfileData) => data.idDataType === idDataType && data.indexNBR === index)

        const defaultValue: number = 100

        if (data == null) {
            const newData: OpConfigurationProfileData = new OpConfigurationProfileData(null)
            newData.idDataType = idDataType
            newData.value = defaultValue
            newData.opState = Enums.OpChangeState.New
            newData.indexNBR = index

            this.dataSource.push(newData)
        }

        const selectBoxOption: dxSelectBoxOptions = {
            dataSource: this.getSelectBoxDataSource(),
            value: data != null && data.value != null ? data.value : defaultValue,
            displayExpr: (item: any) => {
                return item + ' %'
            },
            onInitialized: (e: any) => {
                list[index] = e.component
            },
            onValueChanged: (e: any) => {
                if (index != this.PERIOD_COUNT - 1 && _.size(list) === this.PERIOD_COUNT) {
                    list[index + 1].option('value', e.value)

                    if (dayType == DayType.WorkDay) {
                        this.weekEndSelectBox[index].option('value', e.value)
                        this.holidaySelectBox[index].option('value', e.value)
                    }
                }

                const itemData: OpConfigurationProfileData = _.find(this.dataSource, (data: OpConfigurationProfileData) => data.idDataType === idDataType && data.indexNBR === index)

                if (itemData != null) {
                    itemData.value = e.value
                    itemData.opState = itemData.opState != Enums.OpChangeState.New ? Enums.OpChangeState.Modified : Enums.OpChangeState.New
                }
            }
        }

        return selectBoxOption
    }

    private setAllSelectBoxOptions(): void {
        this.hourList = []
        this.workDaySelectBoxOption = []
        this.weekEndSelectBoxOption = []
        this.holidaySelectBoxOption = []
        this.workDaySelectBox = new Array(this.PERIOD_COUNT)
        this.weekEndSelectBox = new Array(this.PERIOD_COUNT)
        this.holidaySelectBox = new Array(this.PERIOD_COUNT)

        setTimeout(() => {
            for (let i = 0; i < this.PERIOD_COUNT; i++) {
                this.workDaySelectBoxOption.push(this.getSingleSelectBoxOptions(i, this.workDaySelectBox, Enums.DataType.DALI_WORKDAY_POWER_LEVEL, DayType.WorkDay))
                this.weekEndSelectBoxOption.push(this.getSingleSelectBoxOptions(i, this.weekEndSelectBox, Enums.DataType.DALI_WEEKEND_POWER_LEVEL, DayType.Weekend))
                this.holidaySelectBoxOption.push(this.getSingleSelectBoxOptions(i, this.holidaySelectBox, Enums.DataType.DALI_HOLIDAY_POWER_LEVEL, DayType.Holiday))

                const first: string = `${(i < 10) ? '0' + i : i}`
                const second: string = `${(i + 1 < 10) ? '0' + (i + 1) : (i + 1)}`
                const item: string = `${first}:00 - ${second}:00`

                this.hourList.push(item)
            }
        })
    }

    private setDeviceTypeTagBoxOptions(): void {
        this.loadedDeviceTypes = _.uniq(_.map(this.options.dataSource, (item) => { return item.idDeviceType }))

        this.getDataTypeTagBoxDataSource()
            .then((deviceTypes: OpDeviceTypeProfileMap[]) => {
                this.deviceTypeTagBoxOptions = {
                    value: [...this.loadedDeviceTypes],
                    dataSource: deviceTypes,
                    displayExpr: (item: OpDeviceTypeProfileMap) => {
                        if (item == null) {
                            return ''
                        }

                        return item.toString()
                    },
                    valueExpr: 'idDeviceType',
                    onInitialized: (e: any) => {
                        this.deviceTypeTagBox = e.component
                    }
                }
            })
    }

    private setDeviceTypeTagBoxValidatorOptions(): void {
        this.deviceTypeTagBoxValidatorOptions = {
            validationRules: [{
                type: "required",
                message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RequiredField)
            }],
            onInitialized: (e: any) => {
                this.deviceTypeTagBoxValidator = e.component
            }
        }
    }

    private getDataTypeTagBoxDataSource(): JQueryPromise<OpDeviceTypeProfileMap[]> {
        return this.userSessionService
            .getDataProvider()
            .ConfigurationProfile
            .getAllDeviceTypeProfileMap()
            .then((deviceTypes: OpDeviceTypeProfileMap[]) => {
                return deviceTypes
            })
    }

    private prepareHtmlDescr(): string {
        const periods: string = _.map(this.hourList, (item: string) => `<p>${item}</p>`).join('')
        const workday: string = _.map(this.workDaySelectBox, (box: dxSelectBox) => `<p>${box.option('value')}%</p>`).join('')
        const weekend: string = _.map(this.weekEndSelectBox, (box: dxSelectBox) => `<p>${box.option('value')}%</p>`).join('')
        const holiday: string = _.map(this.holidaySelectBox, (box: dxSelectBox) => `<p>${box.option('value')}%</p>`).join('')

        const preparedString: string = `<p style="font-size:18px;text-align:center"><strong>${this.scheduleText}</strong></p><div style="display:grid;grid-template-columns:auto auto auto auto"><div style="text-align:center"><strong><p>${this.hoursText}</p></strong>${periods}</div><div style="text-align:center"><strong><p>${this.workdayText}</p></strong>${workday}</div><div style="text-align:center"><strong><p>${this.weekendText}</p></strong>${weekend}</div><div style="text-align:center"><strong><p>${this.holidaysText}</p></strong>${holiday}</div></div>`

        return preparedString
    }

}
